import React, { useState } from "react";
import { Eye, EyeOff, LogIn } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";
import toast from "react-hot-toast";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(email, password);
      toast.success("Login successful!");
    } catch (error) {
      toast.error(error.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const demoAccounts = [
    {
      email: "admin@giss.edu",
      password: "admin123",
      role: "Admin",
      description: "Full system access",
    },
    {
      email: "librarian@giss.edu",
      password: "lib123",
      role: "Librarian",
      description: "Library management",
    },
    {
      email: "teacher@giss.edu",
      password: "teacher123",
      role: "Teacher",
      description: "Borrowing & transportation",
    },
    {
      email: "student@giss.edu",
      password: "student123",
      role: "Student",
      description: "View own data",
    },
    {
      email: "parent@giss.edu",
      password: "parent123",
      role: "Parent",
      description: "Child monitoring & controls",
    },
  ];

  const fillDemoAccount = (demoEmail, demoPassword) => {
    setEmail(demoEmail);
    setPassword(demoPassword);
  };

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="background-pattern"></div>
      </div>

      <div className="login-content">
        <div className="login-card">
          <div className="login-header">
            <div className="logo">
              <img src="/logo.png" alt="GISS Logo" className="logo-image" />
              <h1>GISS Library Management System</h1>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                  className="form-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="password-toggle"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <button type="submit" disabled={loading} className="login-btn">
              {loading ? (
                <div className="loading-spinner"></div>
              ) : (
                <>
                  <LogIn size={20} />
                  Sign In
                </>
              )}
            </button>
          </form>

          <div className="demo-accounts">
            <h3>Demo Accounts</h3>
            <p>Click any account to auto-fill credentials:</p>
            <div className="demo-grid">
              {demoAccounts.map((account, index) => (
                <button
                  key={index}
                  onClick={() =>
                    fillDemoAccount(account.email, account.password)
                  }
                  className="demo-account"
                >
                  <div className="demo-role">{account.role}</div>
                  <div className="demo-email">{account.email}</div>
                  <div className="demo-description">{account.description}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
